module.exports = __webpack_public_path__ + "img/messicon.422917a6.svg";